import { connect } from 'react-redux'

import { push } from '@lagunovsky/redux-react-router'
import { handleBasketConfirm, loadData, releaseBasketAndLoadHall, setError, setWarning } from './reducer'

const mapStateToProps = (state) => {
    const seatingError = state?.pages?.hall?.seating?.error
    const hallError = state?.pages?.hall?.movie?.error

    return {
        isAuth: state?.services?.auth?.isAuthorized,
        data: state?.pages?.hall?.movie?.data ?? null,
        loading: state?.pages?.hall?.movie?.loading ?? false,
        urlParamsOk: state?.pages?.hall?.movie?.urlParamsOk ?? true,
        error: seatingError || hallError || null,
        modalWarning: state?.pages?.hall?.movie?.modalWarning ?? null,
        selectedSeats: state?.pages?.hall?.movie?.selectedSeats ?? null,
        disable: state?.pages?.hall?.movie?.disable ?? null,
        emptyBasket: !state?.components?.basket?.data?.items_tickets?.length,
    }
}

const mapDispatchToProps = { loadData, setError, releaseBasketAndLoadHall, setWarning, handleBasketConfirm, push }

const hocConnect = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocConnect
